import styled from 'styled-components';

export const Container = styled.section`
  width: 50%;
  margin: 2rem 1rem 0 auto;
  padding-bottom: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: calc(${({ theme }) => theme.breakpoints.laptopL} + 0.5rem);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  flex-direction: row;

  & > button:first-child {
    width: 100%;
  }

  & > button:last-child {
    width: 100%;
  }
`;
